import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AuthService } from './auth.service';
import { ApplicationState } from '../../store/application-store';
import { GlobalStartupService } from '../../common/services/global-startup-service';
import * as authActions from '../actions/auth';

@Injectable()
export class AuthGuardService  {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.authService.isAuthenticated()) {
      this.globalStartupService.initSystemSettings();
      return of(true); // currently we are always authed
    } else {
      this.store.dispatch(new authActions.LoginRedirect({ returnUrl: state.url }));
      return of(false);
    }
  }

  constructor(
    private authService: AuthService,
    private store: Store<ApplicationState>,
    private globalStartupService: GlobalStartupService) {
  }

}
